import { render, staticRenderFns } from "./addLicensesDetails.vue?vue&type=template&id=071b4984"
import script from "./addLicensesDetails.vue?vue&type=script&lang=js"
export * from "./addLicensesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports